<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <app-panel-header
      titleKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.total.fees"
      tooltipKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.service.total.tooltip"
    ></app-panel-header>
    <span class="panel-header-key-value">
      <span> {{ 'common.total' | transloco }}: </span>
      <span class="font-bold text-green-500">
        {{ this.grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
      </span>
    </span>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <p-table [value]="feeRows()">
    <ng-template #header>
      <tr>
        <th>{{ 'common.category' | transloco }}</th>
        @for (year of inputObject().scopeYears; track year) {
          <th class="w-[9%] text-right">{{ 'common.year' | transloco }} {{ year }}</th>
        }

        <th class="w-[9%] text-right">{{ 'common.total' | transloco }}</th>
        <th class="w-[3%] text-right">
          <span class="invisible">{{ 'common.comment' | transloco }}</span>
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-row>
      <tr>
        <td>{{ row.data.categoryLabel || (row.data.categoryTitle | transloco) }}</td>

        @for (fee of row.yearlyFees; track $index) {
          <td class="w-[9%] text-right" [ngClass]="row.data.color">
            {{ fee ? (fee | appCurrency: inputObject() : 0 : 0) : '---' }}
          </td>
        }

        <td class="w-[9%] text-right font-semibold" [ngClass]="row.data.color">
          {{ row.totalAcrossScope | appCurrency: inputObject() : 0 : 0 }}
        </td>
        <td class="w-[3%]"></td>
      </tr>
    </ng-template>
    <ng-template #footer>
      <tr class="font-bold">
        <td>{{ 'common.total' | transloco }}</td>

        @for (year of inputObject().scopeYears; track year) {
          <td class="w-[9%] text-right">
            {{ this.columnTotalsPerYear()[year - 1] | appCurrency: inputObject() : 0 : 0 }}
          </td>
        }

        <td class="w-[9%] text-right">
          {{ this.grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
        </td>
        <td class="w-[3%]"></td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
